import { action, actionOn, thunk } from "easy-peasy";
import axios from '../services/axios';

const helpCenterInitialState = {
    tree: [],
    isFetchingTree: false,
    isTreeFetched: false,
    articleById: null,
    isFetchingArticleById: false,
    isOpen: false,
    isExpanded: false,
    view: 'home',
    isLauncherHidden: false,
}

const helpCenter = {
    ...helpCenterInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    tree: state.tree,
                    isFetchingTree: state.isFetchingTree,
                    isTreeFetched: state.isTreeFetched,
                    articleById: state.articleById,
                    isFetchingArticleById: state.isFetchingArticleById,
                    isOpen: state.isOpen,
                    isExpanded: state.isExpanded,
                    view: state.view,
                    isLauncherHidden: state.isLauncherHidden,
                } = helpCenterInitialState);
            }
        }
    ),

    setTree: action((state, payload) => {
        state.tree = payload;
    }),

    setIsFetchingTree: action((state, payload) => {
        state.isFetchingTree = payload;
    }),

    setIsTreeFetched: action((state, payload) => {
        state.isTreeFetched = payload;
    }),

    setIsOpen: action((state, payload) => {
        state.isOpen = payload;
    }),

    setIsExpanded: action((state, payload) => {
        state.isExpanded = payload;
    }),

    setView: action((state, payload) => {
        state.view = payload;
    }),

    setIsLauncherHidden: action((state, payload) => {
        state.isLauncherHidden = payload;
    }),

    openWidgetContactForm: action((state) => {
        state.view = 'contact';
        state.isOpen = true;
    }),

    openWidgetHome: action((state) => {
        state.view = 'home';
        state.isOpen = true;
    }),

    openArticleById: thunk((actions, payload) => {
        actions.openWidgetHome();
        actions.fetchArticleById(payload);
    }),

    closeWidget: action((state) => {
        state.isOpen = false;
    }),

    fetchHelpCenterTree: thunk((actions, payload, helpers) => {
        const { isFetchingTree, isTreeFetched } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const getUrl = ACTIONS?.helpCenter?.readAll?.url;

        if (!isFetchingTree && !isTreeFetched) {
            actions.setIsFetchingTree(true);

            return axios.get(getUrl)
                .then(data => {
                    actions.setTree(data.data ?? []);
                    actions.setIsTreeFetched(true);
                    return data;
                })
                .catch(error => {
                    return Promise.reject(error);
                })
                .finally(() => {
                    actions.setIsFetchingTree(false);
                });
        } else {
            return Promise.resolve();
        }
    }),

    setArticleById: action((state, payload) => {
        state.articleById = payload;
    }),

    setIsFetchingArticleById: action((state, payload) => {
        state.isFetchingArticleById = payload;
    }),

    fetchArticleById: thunk((actions, payload, helpers) => {
        const { isFetchingArticleById } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const getOneUrl = ACTIONS?.helpCenter?.readOne?.url?.replace('id', payload);

        if (!isFetchingArticleById) {
            actions.setIsFetchingArticleById(true);
            actions.setArticleById(helpCenterInitialState.articleById);

            return axios.get(getOneUrl)
                .then(data => {
                    actions.setArticleById(data?.data?.[0] ?? null);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingArticleById(helpCenterInitialState.isFetchingArticleById);
                });
        } else {
            return Promise.resolve();
        }
    }),
};

export default helpCenter;
